"use client";

import StatItem2 from "./StatItem2";

export default function Stats2({ slice }) {
  return (
    <div className="relative h-full">
      <div className=" w-full md:relative md:h-full md:flex grid grid-cols-2 [&>div:nth-last-child(2)]:border-b-0">
        {slice.primary.stats.map((item, index) => {
          return (
            <StatItem2
              key={`stat_item_2_${index}`}
              title={item.title}
              subTitle={item.sub_title}
            />
          );
        })}
      </div>
    </div>
  );
}
